import emojiRegex from 'emoji-regex';

export const deepClone = (obj: any): any => {
  if (!obj) {
    return;
  }

  return JSON.parse(JSON.stringify(obj));
};

export const convertToSceneOrderIndex = (categoryIndex: number, sceneIndex: number) => {
  return categoryIndex * 1000 + sceneIndex;
};

export const getCategoryOrderIndex = (orderIndex: number) => {
  return Math.round(orderIndex / 1000);
};

export const getSceneOrderIndex = (orderIndex: number) => {
  return Math.round(((orderIndex / 1000) % 1) * 1000);
};

export const validateIcons = (_, value) => {
  if (value) {
    const regex = emojiRegex();

    for (const match of value.matchAll(regex)) {
      console.log('match', match);
      return Promise.reject(new Error('Please do not enter icons.'));
    }

    return Promise.resolve();
  }

  return Promise.resolve();
};

export const sleep = (ms: number): Promise<void> => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

export const nonNull = (obj: any): boolean => {
  return obj !== null && obj !== undefined;
};

export const encodeQueryData = (data = {}): string | undefined => {
  const ret = [];

  Object.keys(data).forEach((key) => {
    let value = data[key];
    if (value && value !== '_all') {
      if (Array.isArray(value)) {
        if (key === 'sort') {
          value.forEach((sortVal) => {
            ret.push(`${encodeURIComponent(key)}=${sortVal}`);
          });
          return;
        }
        const values = value.map((x) =>
          encodeURIComponent(x && x.value !== null && x.value !== undefined ? x.value : x));
        ret.push(`${encodeURIComponent(key)}=${values.join(',')}`);
      } else {
        if (value && typeof value.getMonth === 'function') {
          value = value.toISOString(true);
        } else if (value && typeof value === 'string') {
          value = value.trim();
        }
        ret.push(
          `${encodeURIComponent(key)}=${encodeURIComponent(
            value && value.value !== null && value.value !== undefined ? value.value : value
          )}`
        );
      }
    }
  });

  return ret.join('&');
};

export const getWebRotateLabel = (code: string, name: string): string => {
  return `${code} - ${name}`;
};

export const is24HoursOld = (value: Date | string): boolean => {
  const now = new Date();
  const date = new Date(value);
  const timeDifference = now.getTime() - date.getTime();
  const hoursDifference = timeDifference / (1000 * 60 * 60); // Convert milliseconds to hours

  return hoursDifference >= 24;
};
